import { defineComponent as _defineComponent } from 'vue'
import { VueEditor } from 'vue2-editor'

import BKUserSelect from '@/components/BKUserSelect.vue'
import BKOrganizationSelect from '@/components/BKOrganizationSelect.vue'
import GmapsPlaceInput from '@/components/GmapsPlaceInput.vue'
import CreateEventCancel from '@/pages/CreateEventProcessingPage/ui/CreateEventCancel.vue'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'
import { mdiLeadPencil, mdiUpload } from '@mdi/js'
import { eventApi, EventDB, StaffRole } from '@/enitites/event'
import { computed, inject, ref } from 'vue'
import { useImage } from '@/shared/composables/image'
import { UserDB } from '@/enitites/user'
import BKEditorConfig from '../../../common/vue2Config'
import { CreateEventFormName } from '../model/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventInfo',
  props: {
    isNew: { type: Boolean, default: true },
    eventData: null,
    backStep: { type: Boolean, default: false },
    screen: null
  },
  emits: ["updateEvent", "update:screen", "saveAsDraft"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'updateEvent'): void
  (e: 'update:screen', value: CreateEventFormName): void
  (e: 'saveAsDraft'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isNew: boolean, eventData: EventDB, backStep: boolean, screen: CreateEventFormName };

const { getImageById, saveImage } = useImage()




const getUserDB = computed(() => store.getters.getUserDB)
const isShowImg = ref(props.backStep)
const location = ref({
  address: props.eventData.locationAddress,
  lat: props.eventData.locationLat,
  lng: props.eventData.locationLng,
})
const filesImgEvent = ref<FileList | null>(null)
const srcImgEvent = ref(props.eventData.image ? getImageById(props.eventData.image, 800, 800, 'event') : '')
const loadingNextBtn = ref(false)
const currentDotNav = ref(1)
const error = ref(null)
const editorConfig = ref(BKEditorConfig)
const inputFileRef = ref<HTMLInputElement | null>(null)

function isValidUrl(str: string) {
  try {
    const url = new URL(str)
    return url.protocol === 'https:'
  } catch {
    return false
  }
}

const validateUrlRule = (value: string) => isValidUrl(value) || 'URL should be in the format https://yourwebsite.com'
const isInfoFilledOut = computed(() => !!props.eventData.title)
const adminIds = computed(() => props.eventData.staff.admins.map((user) => user.id))
const djIds = computed(() => props.eventData.staff.djs.map((user) => user.id))
const hostIds = computed(() => props.eventData.staff.hosts.map((user) => user.id))

async function setImageToEvent() {
  if (!filesImgEvent.value) return
  props.eventData.image = await saveImage(filesImgEvent.value[0])
  isShowImg.value = true
}

async function setLocationToEvent() {
  props.eventData.locationAddress = location.value.address
  props.eventData.locationLat = location.value.lat
  props.eventData.locationLng = location.value.lng
}

async function saveAsDraft() {
  if (filesImgEvent.value) await setImageToEvent()
  await setLocationToEvent()

  emit('saveAsDraft')
  loadingNextBtn.value = false
}

const injectedIsClickBtnNext = inject<{
  updateIsClickBtnNext: (value: boolean) => void
}>('isClickBtnNext')

async function handlerClickNext() {
  error.value = null
  loadingNextBtn.value = true

  if (filesImgEvent.value) await setImageToEvent()
  await setLocationToEvent()

  emit('updateEvent')
  loadingNextBtn.value = false
  injectedIsClickBtnNext?.updateIsClickBtnNext(true)

  emit('update:screen', props.backStep ? 'CreateEventTotal' : 'CreateEventDate')
}

function openFileDialog() {
  inputFileRef.value?.click()
}

function handlerFileChange(evt: Event) {
  const filesImg = (evt.target as HTMLInputElement).files
  if (!filesImg?.length) return

  const reader = new FileReader()
  reader.onload = (event) => {
    srcImgEvent.value = event.target?.result as string
    filesImgEvent.value = filesImg
  }
  reader.readAsDataURL(filesImg[0])
}

async function addEventRole(user: UserDB, role: StaffRole) {
  const resp = await eventApi.addRole(props.eventData.id, user.id, role)
  if (resp) props.eventData.staff = resp
}

async function removeEventRole(user: UserDB, role: StaffRole) {
  const resp = await eventApi.removeRole(props.eventData.id, user.id, role)
  if (resp) props.eventData.staff = resp
}

return { __sfc: true,getImageById, saveImage, props, emit, getUserDB, isShowImg, location, filesImgEvent, srcImgEvent, loadingNextBtn, currentDotNav, error, editorConfig, inputFileRef, isValidUrl, validateUrlRule, isInfoFilledOut, adminIds, djIds, hostIds, setImageToEvent, setLocationToEvent, saveAsDraft, injectedIsClickBtnNext, handlerClickNext, openFileDialog, handlerFileChange, addEventRole, removeEventRole, VueEditor, BKUserSelect, BKOrganizationSelect, GmapsPlaceInput, CreateEventCancel, store, mdiLeadPencil, mdiUpload }
}

})